import { render, staticRenderFns } from "./VotesBrowser.vue?vue&type=template&id=0e9d2d98&scoped=true"
import script from "./VotesBrowser.vue?vue&type=script&lang=ts"
export * from "./VotesBrowser.vue?vue&type=script&lang=ts"
import style0 from "./VotesBrowser.vue?vue&type=style&index=0&id=0e9d2d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9d2d98",
  null
  
)

export default component.exports